import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const footerLinks = [
    { path: "/", text: "Home" },
    // { path: "/about", text: "About Us" },
    { path: "/#projects", text: "Projects" },
    // { path: "/#insights", text: "Insights" },
    // { path: "/contact", text: "Contact" },
  ];

  const services = ["Design", "Marketing", "Planning", "Research", "Engineering"];

  const features = [
    { icon: "✓", text: "Access to Qualified Talent" },
    { icon: "✓", text: "Real-World Project Insights" },
    { icon: "✓", text: "Shape Industry Standards" },
  ];

  const CheckIcon = () => (
    <svg
      className="w-5 h-5 mr-2 text-green-400"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
  );

  const ArrowIcon = () => (
    <svg
      className="w-5 h-5 ml-2"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M14 5l7 7m0 0l-7 7m7-7H3"
      />
    </svg>
  );

  const EmailIcon = () => (
    <svg
      className="w-5 h-5 mr-3 text-blue-400"
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
      />
    </svg>
  );

  const LinkedInIcon = () => (
    <svg
      className="w-5 h-5"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
    </svg>
  );

  return (
    <footer className="footer text-white">
      <div className="container mx-auto px-4 py-12">
        {/* Call to Action Section */}
        <div className="bg-[#ECEBEB] text-[#000] rounded-xl p-8 mb-12 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
            <div className="md:col-span-2">
              <h3 className="text-2xl font-bold mb-4">For Industry Partners</h3>
              <p className="text-[#000000] mb-4 md:pr-12">
              Connect with our team to provide case study examples for research and development.
              </p>
              <div className="flex flex-wrap gap-4 items-center">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-center"
                  >
                    <CheckIcon />
                    <span>{feature.text}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="text-center md:text-right">
              <a
                href="https://www.linkedin.com/company/info-impact"
                target="_blank"
                className="conversation-btn !text-[#0258DA] hover:!bg-[#0258DA] hover:text-white text-lg font-medium inline-flex items-center justify-center px-6 py-3 bg-white rounded-lg transition-colors"
              >
                Start a Conversation
                <ArrowIcon />
              </a>
            </div>
          </div>
        </div>

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Company Info Section */}
          <div className="md:col-span-8">
            <div className="mb-8">
              <h3 className="text-xl font-bold mb-4">Our Platform Promise</h3>
              <p className="text-gray-300 mb-6 max-w-2xl">
                Inspired by our founder's vision, we will remain focused on community advancement
                through industry exposure and remain intentional in developing innovation across
                generations{" "}
              </p>
            </div>
          </div>

          {/*<div className="md:col-span-4">*/}
          {/*  /!* Contact Information *!/*/}
          {/*  <div className="mb-8">*/}
          {/*    <h4 className="footer-heading">Contact Us</h4>*/}
          {/*    <div className="flex items-center mb-4">*/}
          {/*      <EmailIcon />*/}
          {/*      <a*/}
          {/*        href="mailto:info@innovatedesign.com"*/}
          {/*        className="text-gray-300 hover:text-white transition duration-200"*/}
          {/*      >*/}
          {/*        info@innovatedesign.com*/}
          {/*      </a>*/}
          {/*    </div>*/}
          {/*  </div>*/}

          {/*  /!* Social Media *!/*/}
          {/*  <div>*/}
          {/*    <h4 className="text-sm font-semibold mb-3 text-gray-300">CONNECT WITH US</h4>*/}
          {/*    <a*/}
          {/*      href="https://www.linkedin.com/company/info-impact"*/}
          {/*      target="_blank"*/}
          {/*      className="social-icon inline-flex items-center justify-center w-10 h-10 bg-white/10 rounded-full hover:bg-blue-600 transition-colors"*/}
          {/*      aria-label="LinkedIn"*/}
          {/*    >*/}
          {/*      <LinkedInIcon />*/}
          {/*    </a>*/}
          {/*  </div>*/}
          {/*</div>*/}

          {/* Services */}
          {/* <div className="md:col-span-2">
            <h4 className="footer-heading">Our Insights</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a
                    href="#"
                    className="footer-link hover:text-white hover:translate-x-1 transition-all duration-200"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          {/* Quick Links */}
          {/* <div className="md:col-span-2">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="space-y-3">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="footer-link hover:text-white hover:translate-x-1 transition-all duration-200"
                  >
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div> */}
        </div>

        {/* Footer Bottom */}
        <div className="border-t border-blue-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-white text-sm mb-4 md:mb-0">
              © 2025 IMPACT. Students Matter Most.
            </div>
            <div className="text-white text-sm space-x-6">
              <Link
                to="/privacy"
                className="hover:!text-white text-white transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="hover:!text-white text-white transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
          {/*<div className="text-center mt-6">*/}
          {/*  <p className="text-white text-sm">*/}
          {/*    Specializing in Growth Partnerships for Industry Leaders*/}
          {/*  </p>*/}
          {/*</div>*/}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
